import banners from './bannerEventsData.json';
import footer from './footerData.json';
import navigationMenuData from './navigationMenuData.json';
import stickerLink from './stickerLinkData.json';
import cookiesData from './cookiesData.json';
import eventsData from './eventsDataData.json';
import eventsListData from './eventsListsData.json';

export default {
  sectionName: 'ventures',
  navigationMenuData,
  banners: banners.bannerEventsData,
  stickerLink,
  cookiesData,
  footer,
  eventsData,
  eventsListData,
};
